<template>
    <div class="card mt-3">
        <div class="card-body">
            <h6 class="card-title">Select Tags from {{ query.queryName }}</h6>
            <div class="row">
                <div
                    v-for="tag in query.tagArr"
                    :key="tag.tagId"
                    class="col-4">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            :value="{ pollingGroupId: pollingGroup.pollingGroupId, queryId: query.queryId, tagId: tag.tagId }"
                            v-model="uploadGroup.selectedTagArr"
                            :disabled="selectedTagIdsFromAllUploadGroupsArr.indexOf(tag.tagId) !== -1 ? true : false">
                        <label class="form-check-label">
                            {{ tag.tagName }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checkbox: []
        }
    },
    computed: {
        selectedTagIdsFromAllUploadGroupsArr() {
            let arr = []
            for (let i = 0; i < this.uploadGroupArr.length; i++) {
                if(this.uploadGroupArr[i].uploadGroupId === this.uploadGroup.uploadGroupId) {
                    continue
                } else {
                    this.uploadGroupArr[i].selectedTagArr.forEach((selectedTagObj) => {
                        arr.push(selectedTagObj.tagId)
                    })
                }
            }
            return arr
        }
    },
    props: ['query', 'pollingGroup', 'uploadGroup', 'uploadGroupArr']
}
</script>



// WEBPACK FOOTER //
// src/components/upload-group/TagSelection.vue